module.exports = __WEBPACK_EXTERNAL_MODULE__opentelemetry_sdk_trace_web__;